import React, {ReactNode} from "react";
import classNames from "classnames";

import type {MuiIconExternalProps} from "../icons/MuiIcon";

import "./MainSidebar.css";

export interface MainSidebarItem {
    id: string;
    label: string;
    Icon: React.ComponentType<MuiIconExternalProps>;
    isActive: boolean;
    onClick: () => void;
}

export interface MainSidebarProps {
    isCollapsed: boolean;
    isOverlay?: boolean;
    tools: MainSidebarItem[];
    settings: MainSidebarItem[];
    header?: ReactNode;
    upgradeCard?: ReactNode;
}

export const MainSidebar = ({
    isCollapsed,
    isOverlay = false,
    tools,
    settings,
    header,
    upgradeCard,
}: MainSidebarProps) => {
    return (
        <aside className={classNames("MainSidebar", "theme-dark", {
            "MainSidebar--collapsed": isCollapsed,
            "MainSidebar--overlay": isOverlay,
        })}>
            {header}
            <div className="MainSidebar__inner title-small">
                <nav className="MainSidebar_section">
                    <MainSidebarItems items={tools} isCollapsed={isCollapsed}/>
                </nav>
                <nav className="MainSidebar_section">
                    {upgradeCard}
                    <MainSidebarItems items={settings} isCollapsed={isCollapsed}/>
                </nav>
            </div>
        </aside>
    );
};

const MainSidebarItems = ({items, isCollapsed}: {items: MainSidebarItem[]; isCollapsed: boolean}) => {
    return (
        <>
            {items.map((item) => {
                const Icon = item.Icon;

                return (
                    <div
                        key={item.id}
                        className={classNames("MainSidebar_item", {
                            "MainSidebar_item--active": item.isActive,
                        })}
                        onClick={item.onClick}
                    >
                        <Icon size={24}/>
                        {!isCollapsed && <span className="MainSidebar__label">{item.label}</span>}
                    </div>
                );
            })}
        </>
    );
};
